/** Workspace roles: company = client/admin; member = invited user */

export const ORG_ROLE_COMPANY = 'company';
export const ORG_ROLE_MEMBER = 'member';

export function isCompanyRole(role) {
  return role === ORG_ROLE_COMPANY;
}

/** Manage members, billing, workspace settings */
export function canManageOrgSettings(role) {
  return role === ORG_ROLE_COMPANY;
}

/** Create/delete spaces at org level */
export function canCreateOrgSpace(role) {
  return role === ORG_ROLE_COMPANY || role === ORG_ROLE_MEMBER;
}

export function canDeleteOrgSpace(role) {
  return role === ORG_ROLE_COMPANY;
}

/** Document editing when space access allows (org role gate) */
export function canEditDocumentsOrgRole(role) {
  return role === ORG_ROLE_COMPANY || role === ORG_ROLE_MEMBER;
}

export const ROLE_BADGE_CLASSES = {
  company: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400',
  member: 'bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-400',
  owner: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400',
  admin: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
  editor: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400',
  viewer: 'bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-400',
};

export function orgRoleBadgeClass(role) {
  return ROLE_BADGE_CLASSES[role] || ROLE_BADGE_CLASSES.member;
}

/** UI label for API role string */
export function formatOrgRoleLabel(role) {
  if (!role) return 'Member';
  if (role === 'company' || role === 'owner' || role === 'admin') return 'Company';
  if (role === 'member' || role === 'editor' || role === 'viewer') return 'Member';
  return role.charAt(0).toUpperCase() + role.slice(1);
}
